<template>
  <div class="d-flex">
    <div class="menu__item menu__item--column300">
      <div class="menu__title">Resource Centre</div>
      <ul class="menu__list-type1">
        <li v-for="link in rcLinks">
          <a class="menu__link-type1" :href="link.url">{{ link.value }}</a>
        </li>
      </ul>
    </div>
  </div>

</template>

<script setup>
const rcLinks = {
  retirementVillages: {
    url: '/resource-centre/retirement-villages',
    value: 'Retirement Village Advice & Guides',
  },
  villageLife: {
    url: '/resource-centre/care-home-resources',
    value: 'Rest Home Advice & Guides',
  },
  videos: {
    url: '/resource-centre/videos',
    value: 'Video Knowledge Centre',
  },
};
</script>
